"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapValues = void 0;
function mapValues(object, callback) {
    var results = [];
    for (var key in object) {
        results.push(callback(object[key], key));
    }
    return results;
}
exports.mapValues = mapValues;
